// Module
var code = `<h4 style="text-align: center">Таблица реактивации пользователей</h4>
<table class="table" ng-if="vm.rows.length > 0" fixed-table-headers="scrollable-area" ng-table>
    <tr>
        <th>Date</th>
        <th ng-repeat="k in vm.columns" class="text-capitalize">{{ k }}</th>
    </tr>
    <tr
        ng-repeat="row in vm.rows"
        ng-style="\$first && {'background-color': '#FFEBCD'}"
    >
        <td>{{ row.date }}</td>
        <td
            ng-repeat="k in vm.columns"
            ng-style="{'background-color': get_bg_color(row[k], k)}"
        >
            {{ row[k] }}
        </td>
    </tr>
</table>
`;
// Exports
module.exports = code;